import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import Style from '../../../../constants/Style';
import Colors from '../../../../constants/Colors';
import QueueIcon40 from '../../../40pxIcons/QueueIcon40';
import TablesIcon40 from '../../../40pxIcons/TablesIcon40';
import ChartBarIcon from '../../../16pxIcons/ChartBarIcon';

const TableOccupancyWidget = () => {
  const queue: number = 3;
  const tablesOccupied: number = 8;
  const tablesCapacity: number = 12;
  const occupationPercentage: number = (tablesOccupied / tablesCapacity) * 100;

  return <View style={[Style.row, styles.overview]}>
    <View style={styles.section}>
      <View style={styles.iconContainer}>
        <QueueIcon40 />
        <ChartBarIcon style={styles.chartIcon} />
      </View>
      <Text style={styles.title}>{'Queue'}</Text>
      <Text style={styles.value}>{queue ?? '-'}</Text>
    </View>
    {false && <View style={styles.section}>
      <View style={styles.iconContainer}>
        <TablesIcon40 />
        <ChartBarIcon style={styles.chartIcon} />
      </View>
      <View style={Style.row}>
        <View>
          <Text style={styles.title}>{'Tables occupied'}</Text>
          <Text style={styles.value}>
            {tablesOccupied ?? '-'}
            <Text style={styles.capacity}>{`/${tablesCapacity ?? '-'}`}</Text>
          </Text>
        </View>
        <View style={styles.progressBarTrack}>
          <View style={[
            styles.progressBarFill, { width: `${Math.min(100, occupationPercentage)}%` },
          ]} />
        </View>
      </View>
    </View>}
  </View>;
};

const styles = StyleSheet.create({
  overview: {
    marginHorizontal: -8,
    marginBottom: 16,
  },
  section: {
    flex: 1,
    padding: 16,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: Colors.light.hereworksWhite300,
    backgroundColor: '#FFF',
    marginHorizontal: 8,
  },
  iconContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  title: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
    marginTop: 12,
    marginBottom: 4,
  },
  value: {
    fontSize: 30,
    lineHeight: 30,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
  },
  capacity: {
    color: Colors.light.hereworksBlack100,
  },
  progressBarTrack: {
    marginStart: 30,
    flex: 100,
    height: 16,
    borderRadius: 8,
    backgroundColor: Colors.light.hereworksWhite500,
  },
  progressBarFill: {
    backgroundColor: Colors.light.hereworksDarkBlue,
    borderRadius: 8,
    height: '100%',
  },
  chartIcon: {
    backgroundColor: Colors.light.hereworksWhite200,
    borderRadius: 4,
    padding: 4,
  },
});

export default TableOccupancyWidget;
